import { AfterContentInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[igEmptyValue]',
})
export class EmptyValueDirective implements AfterContentInit {
  readonly #el = inject(ElementRef);

  ngAfterContentInit() {
    if (this.#el.nativeElement.children.length !== 0 || this.#el.nativeElement.innerText !== '') {
      return;
    }

    this.#el.nativeElement.innerHTML =
      '<span class="ig-color-label">n.a.</span>';
  }
}
